import {
	Component,
	OnInit,
	Input,
	ViewContainerRef,
	TemplateRef,
	ChangeDetectorRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import {
	LoadingIndicatorService,
	UNIVERSAL_LOADING_KEY,
} from 'src/app/services/loading-indicator.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
	selector: 'app-loading-indicator',
	templateUrl: './loading-indicator.component.html',
	styleUrls: ['./loading-indicator.component.scss'],
	imports: [MatProgressSpinner],
})
export class LoadingIndicatorComponent implements OnInit {
	@Input() keys!: string[];
	@Input() diameter!: string;

	@Input() spinnerAlign: 'left' | 'center' | 'right' = 'center';

	@Input() boxWidth?: string;
	@Input() boxHeight?: string;

	@Input() boxMinWidth?: string;
	@Input() boxMinHeight?: string;

	@Input() boxStyle: any = {};
	@Input() spinnerStyle: any = {};

	loadingStarted: Subscription;
	loadingStopped: Subscription;

	constructor(
		private readonly changeDetector: ChangeDetectorRef,
		private readonly loadingService: LoadingIndicatorService
	) {
		this.loadingStarted = this.loadingService.loadingStarted.subscribe(
			(key) => {
				if (this.keys?.includes(key)) {
					this.showIndicator();
				}
			}
		);

		this.loadingStopped = this.loadingService.loadingStopped.subscribe(
			(key) => {
				if (this.isLoading === false) {
					this.hideIndicator();
				}
			}
		);
	}

	ngOnInit(): void {
		if (this.keys === undefined) {
			this.keys = [UNIVERSAL_LOADING_KEY];
		}

		this.diameter = this.diameter ?? '50';

		if (this.boxWidth) {
			if (isNaN(Number(this.boxWidth))) {
				this.boxStyle.width = this.boxWidth;
			} else {
				this.boxStyle.width = this.boxWidth + 'px';
			}
		}

		if (this.boxHeight) {
			if (isNaN(Number(this.boxHeight))) {
				this.boxStyle.height = this.boxHeight;
			} else {
				this.boxStyle.height = this.boxHeight + 'px';
			}
		}

		if (this.boxMinWidth) {
			if (isNaN(Number(this.boxMinWidth))) {
				this.boxStyle.minWidth = this.boxMinWidth;
			} else {
				this.boxStyle.minWidth = this.boxMinWidth + 'px';
			}
		}

		if (this.boxMinHeight) {
			if (isNaN(Number(this.boxMinHeight))) {
				this.boxStyle.minHeight = this.boxMinHeight;
			} else {
				this.boxStyle.minHeight = this.boxMinHeight + 'px';
			}
		}

		this.spinnerStyle.width = this.diameter + 'px';
		this.spinnerStyle.height = this.diameter + 'px';

		switch (this.spinnerAlign) {
			case 'left':
				this.spinnerStyle.marginLeft = '0';
				break;
			case 'center':
				this.spinnerStyle.marginLeft = 'auto';
				this.spinnerStyle.marginRight = 'auto';
				break;
			case 'right':
				this.spinnerStyle.marginRight = '0';
				break;
		}

		if (this.isLoading) {
			this.showIndicator();
		}
	}

	get isLoading(): boolean {
		if (!this.keys || !Array.isArray(this.keys)) {
			return false;
		}
		for (const key of this.keys) {
			if (this.loadingService.isLoading(key) === true) {
				return true;
			}
		}
		return false;
	}

	showIndicator(): void {
		this.changeDetector.detectChanges();
	}

	hideIndicator(): void {
		this.changeDetector.detectChanges();
	}
}
